import Button from "../../../components/button/Button";
import ArrowSmall from "../../../components/svg/ArrowSmall";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectOpenBills } from "../../../features/reservation/reservationSlice";
import Payment from "../../../components/kiosk/Payment";

export default function OpenBills() {
	const openBills = useSelector(selectOpenBills);
	const navigate = useNavigate();

	return (
		<>
			{openBills !== null && (
				<>
					<div className="flex-grow flex justify-center items-center flex-col w-full">
						<div className="text-h1 text-center">
							These have been your consumptions during your stay.
						</div>
						<div className="mt-12 w-full">
							<Payment
								openBills={openBills}
								minimalAmount={0}
								callBack={() => navigate("/kiosk/check-out/feedback")}
							/>
						</div>
					</div>
					{openBills.Total.GrossValue === 0 && (
						<div className="h-48 flex justify-between items-center w-3/4 text-h3 text-center">
							<Button
								link={`/kiosk/check-out/feedback`}
								text="Next"
								suffix={<ArrowSmall />}
							/>
						</div>
					)}
				</>
			)}
		</>
	);
}
